
import { defineComponent, useContext, useMeta, useRoute } from '@nuxtjs/composition-api';
import { StatusBlock } from '05-ui-kit';
import Specifications from '~/components/Specifications/Specifications.vue';
import FoundError from '~/components/FoundError/FoundError.vue';
import type { ProductExtended } from '~/type/product/Product';
import link from '~/helper/canonical';
import { useFoundErrorStore } from '~/store/modal/foundError';
const __sfc_main = defineComponent({
  head: {}
});
__sfc_main.props = {
  response: {
    key: "response",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const route = useRoute();
  const context = useContext();
  const {
    enableFoundError
  } = useFoundErrorStore();
  useMeta(() => ({
    title: `Характеристики ${props.response?.product?.name} — в интернет-магазине 05 ${props.response?.product?.code}`,
    meta: [{
      hid: 'description',
      name: 'description',
      content: `Технические характеристики ${props.response?.product?.name} ${props.response?.product?.code} в 05.ru ✔ На этой странице вы найдете подробные технические характеристики ${props.response?.product?.name}, которые помогут выбрать товар`
    }, ...(props.response?.product?.metaRobot?.property ? [] : [{
      name: 'robots',
      content: 'noindex'
    }])],
    ...link({
      exclude: [],
      data: {
        route,
        config: context.$config
      }
    })
  }));
  return {
    enableFoundError
  };
};
__sfc_main.components = Object.assign({
  Specifications,
  FoundError,
  StatusBlock
}, __sfc_main.components);
export default __sfc_main;
